import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChicagoStatus } from '@core/util/chicago';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { BlankTitleInsurance } from '../../chicago.component';
import {
	CancelModalComponent,
	CancelModalData,
} from '../cancel-modal/cancel-modal.component';
import { take } from 'rxjs/operators';
import { TestHooks } from './footer.hooks';

@Component({
	selector: 'app-chicago-footer',
	templateUrl: './footer.component.html',
	standalone: false,
})
export class ChicagoFooterComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	@Input() status: number;
	public blankTitleInsurance = BlankTitleInsurance;
	public canCancel: boolean;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	ngOnInit(): void {
		this.canCancel = this.status !== ChicagoStatus.CANCELLED;
	}

	cancel(): void {
		const data: CancelModalData = {
			status: this.status,
		};

		const modalRef = this.dialog.open(CancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					this.matterDispatch.SetTitleInsurance(
						this.matterId,
						this.blankTitleInsurance,
					);
				}
			});
	}
}
